/** Shared nav for public header & footer (in-app routes). */
export const PUBLIC_NAV_LINKS = [
  { label: "Products", to: "/products" },
  { label: "FAQs", to: "/faqs" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Plans", to: "/pricing" },
  { label: "Contact Us", to: "/contact" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Refund Policy", to: "/refund-policy" },
];
